import { EmailConsent } from '@components/consents/EmailConsent';
import { RichText } from '@components/utils/RichText';
import { OutboundLinkContext } from '@enums';
import { FormElementComponent } from '@types';

import { RenderFormFieldComponent } from './RenderFormFieldComponent';

interface Props {
    formElementComponent: FormElementComponent;
    companyName: string;
    outboundLinkContext: OutboundLinkContext;
}

export const RenderFormElementComponent = ({
    formElementComponent,
    companyName,
    outboundLinkContext,
}: Props) => {
    switch (formElementComponent.__typename) {
        case 'ComponentFormFieldsDateInput':
        case 'ComponentFormFieldsInput':
        case 'ComponentFormFieldsFileInput':
        case 'ComponentFormFieldsSingleSelect': {
            return (
                <RenderFormFieldComponent
                    fieldComponent={formElementComponent}
                />
            );
        }

        case 'ComponentConsentsEmail':
            return (
                <EmailConsent
                    companyName={companyName}
                    element={formElementComponent}
                    outboundLinkContext={
                        outboundLinkContext ?? OutboundLinkContext.Modal
                    }
                />
            );

        case 'ComponentDisplayRichText':
            return <RichText element={formElementComponent} />;

        default:
            return null;
    }
};
